<template>
  <div class="page">
    <div id="inicio" />
    <Navbar />

    <Banner :hasBgBlur="true" :haSingleImg="true" :imagem="roteiro.imagem" />

    <v-card tile>
      <v-container>
        <v-col>
          <v-row>
            <Title
              :sub1="roteiro.categoria"
              :titulo="roteiro.nome"
              :hasVideo="false"
              :video="null"
            />
          </v-row>

          <v-row>
            <vue-simple-markdown class="body-1 text-justify" :source="roteiro.descricao"></vue-simple-markdown>
          </v-row>

          <v-row>
            <Map
              :selectedBloco="selectedBloco"
              :centredBloco="centredBloco"
              :idRoteiro="id"
              :blocos="roteiro.blocos"
            />
          </v-row>
        </v-col>
      </v-container>
    </v-card>
    <Footer />
  </div>
</template>



<script>
import Navbar from "@/components/Navbar.vue";
import Map from "@/components/Map.vue";
import Banner from "@/components/Banner.vue";
import Footer from "@/components/Footer.vue";
import Title from "@/components/Title.vue";
import { getCentralMap } from "../globalFunctions";

export default {
  name: "Home",
  components: {
    Navbar,
    Map,
    Banner,
    Title,
    Footer
  },
  destroyed() {
    this.roteiro = {};
    this.id = null;
    this.selectedBloco = 0;
    this.centredBloco = { lat: 0, lng: 0 };
  },
  watch: {
    // call again the method if the route changes
    $route: "getData"
  },
  async mounted() {
    await this.getData();
    await this.centerMap();
    //scroll para o topo
    var elmnt = document.getElementById("inicio");
    elmnt.scrollIntoView();
  },
  data() {
    return {
      id: this.$route.params.id,
      selectedBloco: 0,
      centredBloco: { lat: 0, lng: 0 },
      roteiro: {},
      titulos: []
    };
  },
  methods: {
    async getData() {
      var _roteiro = await this.$store.dispatch(
        "setRoteiro",
        this.$route.params.id
      );
      console.log("roteiro: ", _roteiro);
      this.roteiro = _roteiro;
    },
    async centerMap() {
      var _centredBloco = await getCentralMap(this.roteiro);

      this.centredBloco = {
        lat: _centredBloco.latitude,
        lng: _centredBloco.longitude
      };
    },
    btnShare(id) {
      var btnShare = document.getElementById(id);
      btnShare.click();
    },
    blocoClick(index) {
      this.selectedBloco = index;
      this.centredBloco = this.roteiro.blocos[index].position;

      console.log("pois");

      var elmnt = document.getElementById("bloco-" + index);
      elmnt.scrollIntoView();
    },
    goBloco(idBloco) {
      this.$router.push({ path: this.$route.fullPath + "/bloco/" + idBloco });
    }
  }
};
</script>
